import { __assign } from "tslib";
export function getHeaderAriaLabel(locStrings, currentTab) {
    var gridCellAriaLabel = {
        dateLabel: locStrings.modifiedDateLabel,
        personLabel: locStrings.ownerPersonLabel,
    };
    switch (currentTab) {
        case 'recent':
            return __assign(__assign({}, gridCellAriaLabel), { dateLabel: locStrings.openedDateLabel });
        case 'shared':
            return {
                dateLabel: locStrings.sharedDateLabel,
                personLabel: locStrings.sharedByPersonLabel,
            };
        case 'meetings':
            return __assign(__assign({}, gridCellAriaLabel), { dateLabel: locStrings.startTimeDateLabel });
        case 'attachments':
            return __assign(__assign({}, gridCellAriaLabel), { personLabel: locStrings.attachedByPersonLabel });
    }
    return gridCellAriaLabel;
}
//# sourceMappingURL=getHeaderAriaLabel.js.map